// components/SwEventDrawer/components/MainDetailsSection.jsx
import React from 'react';
import SpInput from '../../SpInput/SpInput';


const MainDetailsSection = ({ formik, getFieldError, handleChange, handleBlur }) => {
  return (
    <div className="sw-event-modal-section">
      <div className="sw-event-section-header">
        Main Details
      </div>
      
      <div style={{ marginBottom: 24 }}>
        <SpInput
          htmlFor="event_name"
          label="Event Name"
          placeholder="Enter event name"
          value={formik.values.event_name}
          onChange={(e) => handleChange('event_name', e.target.value)}
          onBlur={() => handleBlur('event_name')}
          error={getFieldError('event_name')}
          required
        />
      </div>
      
      <div style={{ marginBottom: 24 }}>
        <SpInput
          htmlFor="location"
          label="Location"
          placeholder="Enter event location"
          value={formik.values.location}
          onChange={(e) => handleChange('location', e.target.value)}
          onBlur={() => handleBlur('location')}
          error={getFieldError('location')}
          required
        />
      </div>
      
      <div style={{ marginBottom: 24 }}>
        <SpInput
          htmlFor="start_date"
          label="Start Date"
          type="date"
          value={formik.values.start_date}
          onChange={(e) => handleChange('start_date', e.target.value)}
          onBlur={() => handleBlur('start_date')}
          error={getFieldError('start_date')}
          required
        />
      </div>
      
      <div style={{ marginBottom: 24 }}>
        <SpInput
          htmlFor="end_date"
          label="End Date"
          type="date"
          value={formik.values.end_date}
          onChange={(e) => handleChange('end_date', e.target.value)}
          onBlur={() => handleBlur('end_date')}
          error={getFieldError('end_date')}
          required
        />
      </div>
    </div>
  );
};

export default MainDetailsSection;